import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Environment, EnvConfig } from '..';

@Injectable({
  providedIn: 'root'
})
export class CoreService {
  viewMode = new BehaviorSubject("");

  defaultMode: string;
  constructor(@Inject(EnvConfig) private config: Environment) {
    this.defaultMode = localStorage.getItem('defaultView') || 'list';
    this.viewMode.next(this.defaultMode);
  }

  changeViewMode(data: string) {
    this.viewMode.next(data);
  }

  async encryptLoginDetailsAsync(value: string): Promise<string> {
    if (!value) {
      return '';
    }

    try {
      const passKeyBytes = new TextEncoder().encode(this.config.passKey);
      const keyHash = await crypto.subtle.digest('SHA-256', passKeyBytes);
      
      const cryptoKey = await crypto.subtle.importKey(
        'raw',
        keyHash,
        { name: 'AES-GCM' },
        false,
        ['encrypt']
      );

      const nonce = new Uint8Array(12);
      crypto.getRandomValues(nonce);

      const plaintextBytes = new TextEncoder().encode(value);
      const encryptedData = await crypto.subtle.encrypt(
        {
          name: 'AES-GCM',
          iv: nonce,
          tagLength: 128 // 16 bytes tag
        },
        cryptoKey,
        plaintextBytes
      );

      const encryptedArray = new Uint8Array(encryptedData);
      const tagLength = 16;
      const ciphertextLength = encryptedArray.length - tagLength;
      
      const ciphertext = encryptedArray.slice(0, ciphertextLength);
      const tag = encryptedArray.slice(ciphertextLength);

      // Combine in backend format: [nonce (12)][tag (16)][ciphertext]
      const result = new Uint8Array(12 + 16 + ciphertext.length);
      result.set(nonce, 0);
      result.set(tag, 12);
      result.set(ciphertext, 28);

      // Convert to base64
      return btoa(String.fromCharCode(...result));
    } catch (error) {
      console.error('Encryption error:', error);
      throw new Error('Failed to encrypt password');
    }
  }

  encryptLoginDetails(value: string): string {
    console.warn('encryptLoginDetails is deprecated. Use encryptLoginDetailsAsync instead.');
    
    if (!value) {
      return '';
    }

    throw new Error('encryptLoginDetails must be replaced with encryptLoginDetailsAsync. Please update calling code to use async/await.');
  }

}
